import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import objectPath from "object-path";
import HMenuItem from "./HMenuItem";
import * as builder from "../../../ducks/builder";
import { toAbsoluteUrl } from "../../..";
import KTMenu from "../../../_assets/js/menu";
import KTOffcanvas from "../../../_assets/js/offcanvas";

const offcanvasOptions = {
  overlay: true,
  baseClass: "kt-header-menu-wrapper",
  closeBy: "kt_header_menu_mobile_close_btn",
  toggleBy: {
    target: "kt_header_mobile_toggler",
    state: "kt-header-mobile__toolbar-toggler--active"
  }
};

export default function HMenu() {
  const offCanvasCommonRef = React.createRef();
  const ktMenuCommonRef = React.createRef();

  const {
    user,
    menuConfig,
    ktMenuClasses,
    rootArrowEnabled,
    headerSelfSkin,
    ulClasses,
    disabledAsideSelfDisplay
  } = useSelector(state => ({
    user: state.auth.user,
    menuConfig: state.builder.menuConfig,
    ktMenuClasses: builder.selectors.getClasses(state, {
      path: "header_menu",
      toString: true
    }),
    rootArrowEnabled: builder.selectors.getConfig(
      state,
      "header.menu.self.root-arrow"
    ),
    headerSelfSkin: builder.selectors.getConfig(state, "header.self.skin"),
    ulClasses: builder.selectors.getClasses(state, {
      path: "header_menu_nav",
      toString: true
    }),
    disabledAsideSelfDisplay:
      objectPath.get(state.builder.layoutConfig, "aside.self.display") === false
  }), shallowEqual);

  const location = useLocation();

  var rolePermissions = user?.roles.reduce((r, i) => r.concat(i.permissions), []).map(i => i.codename);
  var userPermissions = [...new Set(user?.permissions.map(i => i.codename).concat(rolePermissions))];

  const getHeaderLogo = () => {
    let result = "logo-light.png";
    //console.log("props.headerSelfSkin", props.headerSelfSkin);
    if (headerSelfSkin && headerSelfSkin !== "dark") {
      result = "logo-dark.png";
    }
    return toAbsoluteUrl(`/media/logos/${result}`);
  }

  const currentUrl = () => {
    return location.pathname.split(/[?#]/)[0];
  }

  const loadData = () => {
    // Canvas
    initOffCanvas();
    // Menu
    initKTMenu();
  }
  React.useEffect(loadData, []);

  const initOffCanvas = () => {
    // eslint-disable-next-line no-undef
    new KTOffcanvas(offCanvasCommonRef.current, offcanvasOptions);
  };

  const initKTMenu = () => {
    let menuOptions = {
      submenu: {
        desktop: "dropdown",
        tablet: "accordion",
        mobile: "accordion"
      },
      accordion: {
        slideSpeed: 200, // accordion toggle slide speed in milliseconds
        expandAll: false // allow having multiple expanded accordions in the menu
      },
      dropdown: {
        timeout: 50
      }
    };

    let menuDesktopMode = "accordion";
    if (
      ktMenuCommonRef.current.getAttribute("data-ktmenu-dropdown") === "1"
    ) {
      menuDesktopMode = "dropdown";
    }

    if (typeof objectPath.get(menuOptions, "submenu.desktop") === "object") {
      menuOptions.submenu.desktop = {
        default: menuDesktopMode
      };
    }

    // eslint-disable-next-line no-undef
    new KTMenu(ktMenuCommonRef.current, menuOptions);
  };


  const items = menuConfig.header.items;
  return (
    <>
      <button
        className="kt-header-menu-wrapper-close"
        id="kt_header_menu_mobile_close_btn"
      >
        <i className="la la-close" />
      </button>
      <div
        className="kt-header-menu-wrapper"
        id="kt_header_menu_wrapper"
        ref={offCanvasCommonRef}
      >
        {disabledAsideSelfDisplay && (
          <div className="kt-header-logo">
            <Link to="/">
              <img alt="logo" src={getHeaderLogo()} />
            </Link>
          </div>
        )}

        <div
          id="kt_header_menu"
          className={`kt-header-menu kt-header-menu-mobile ${ktMenuClasses}`}
          ref={ktMenuCommonRef}
        >
          <ul className={`kt-menu__nav ${ulClasses}`}>
            {items.map((item, index) => {
              if (userPermissions.indexOf(item.permission) >= 0) {
                return (
                  <React.Fragment key={`hmenuList${index}`}>
                    {item.title && (
                      <HMenuItem
                        item={item}
                        userPermissions={userPermissions}
                        currentUrl={currentUrl()}
                        rootArrowEnabled={rootArrowEnabled}
                      />
                    )}
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </ul>
        </div>
      </div>
    </>
  );
}